
import Button from '../../Atoms/Button/Button'
import './CampaingQuestionsAndAnswers.scss'
import { Table } from 'antd'

const columns = [
  {
    title: "Pregunta",
    dataIndex: "question",
    key: "question",
  },
  {
    title: "Respuesta",
    dataIndex: "answers",
    key: "answers",
  },
  {
    title: "Acciones",
    dataIndex: "actions",
    key: "actions",
    fixed: 'right',
  },
];

const CampaingQuestionsAndAnswers = () => {

  const questionsList = [
    {
      key: 1,
      question: '¿Cómo hago para adquirir el producto?',
      answers: 'Respuesta sencilla con base en pregunta',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    },
    {
      key: 2,
      question: '¿Cómo hago para adquirir el producto?',
      answers: 'Respuesta sencilla con base en pregunta',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    },
    {
      key: 3,
      question: '¿Cómo hago para adquirir el producto?',
      answers: 'Respuesta sencilla con base en pregunta',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    }
  ]

  return (
    <div className="box mt-30 s-pxy-20 m-pxy-50">
      <div className="associate-question_header">
        <p className="source-24">Preguntas y respuestas</p>
        <Button content="Asignar/Crear" type="primary" customClass="s-large m-auto" />
      </div>

      <div className="table-container mt-30">
        <Table columns={columns} dataSource={questionsList} pagination={false} />
      </div>

      <div className="associate-profile-header_buttons">
        <div className="header-buttons_one">
          <Button content="Gestionar campañas" type="primary outline" customClass="s-large m-auto" />
          <Button content="Guardar proceso" type="primary" customClass="s-large m-auto" />
        </div>
        <div className="header-buttons_two">
          <Button content="Guardar y lanzar campaña" type="primary"  customClass="s-large m-auto"/>
        </div>
      </div>
      
    </div>
  )
}

export default CampaingQuestionsAndAnswers

